import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminCustomers() {
  const [users, setUsers] = useState([]);
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    api.get("/admin/users").then(({ data }) => setUsers(data));
    api.get("/admin/newsletter").then(({ data }) => setSubs(data));
  }, []);

  return (
    <div data-testid="admin-customers-page">
      <h1 className="font-serif text-5xl tracking-tighter">Clientes</h1>
      <p className="text-[#5B605E] mt-1">{users.length} cuentas · {subs.length} suscriptores</p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
        <div className="bg-white border border-[#E8E3DA]">
          <h2 className="font-serif text-2xl p-4 border-b border-[#E8E3DA]">Usuarios</h2>
          <table className="w-full text-sm">
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="border-t border-[#E8E3DA]">
                  <td className="px-4 py-2">{u.name}</td>
                  <td className="px-4 py-2">{u.email}</td>
                  <td className="px-4 py-2 text-xs uppercase">{u.role}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="bg-white border border-[#E8E3DA]">
          <h2 className="font-serif text-2xl p-4 border-b border-[#E8E3DA]">Suscriptores newsletter</h2>
          <table className="w-full text-sm">
            <tbody>
              {subs.map((s) => (
                <tr key={s.id} className="border-t border-[#E8E3DA]">
                  <td className="px-4 py-2">{s.email}</td>
                  <td className="px-4 py-2 text-xs text-[#5B605E]">{new Date(s.created_at).toLocaleDateString("es-MX")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
